import { colors } from '@material-ui/core'

import dates from './dates'

import constants from 'constants/index'

const {
  TRANSLATE_KINDS,
  TRANSLATE_SOURCE_TYPES,
  BOX_MESSAGE_COLOR_BY_SOURCE_TYPE,
  MESSAGE_TYPE_ICON_COLOR_BY_SOURCE_TYPE,
  BOX_MESSAGE_COLOR_BY_KIND,
  MESSAGE_TYPE_ICON_COLOR_BY_KIND,
} = constants.ticketMessages

const messageSubTitle = (message) => {
  const kind = TRANSLATE_KINDS[message?.kind] || 'Tipo não identificado'
  const sourceType =
    TRANSLATE_SOURCE_TYPES[message?.sourceType] || 'Remetente não identificado'
  const createdAt = dates.ptBrFormatDateTime(message.createdAt)

  return `${kind} | ${sourceType} | ${createdAt}`
}

const getBoxMessageColor = (message) => {
  return (
    BOX_MESSAGE_COLOR_BY_SOURCE_TYPE[message?.sourceType] ||
    BOX_MESSAGE_COLOR_BY_KIND[message?.kind] ||
    colors.lightGreen['A100']
  )
}

const getIconColor = (message) => {
  return (
    MESSAGE_TYPE_ICON_COLOR_BY_SOURCE_TYPE[message?.sourceType] ||
    MESSAGE_TYPE_ICON_COLOR_BY_KIND[message?.kind] ||
    colors.lightGreen[800]
  )
}

export default {
  messageSubTitle,
  getBoxMessageColor,
  getIconColor,
}
